module.exports = __webpack_public_path__ + "media/images/lb/799-cbd52b2a13a1c6f82a488aaa1ad816fc.svg";